import {
  type Component,
  Show,
  createEffect,
  createSignal,
  onCleanup,
  Suspense,
} from "solid-js";
import { useProductActivity } from "~/services/products";
import { Motion } from "solid-motionone";
import { Icon } from "solid-heroicons";
import {
  users as theEnrapturedMasses,
  fire as letItConsumeYou,
  eye as theAllSeeingEye,
} from "solid-heroicons/solid";

type ViewerCountProps = {
  sku: string;
  class?: string;
};

export const ViewerCount: Component<ViewerCountProps> = (props) => {
  const data = useProductActivity(() => props.sku);
  const [state, setState] = createSignal(true);
  const THIS_ITEM_IS_HOT = 30;

  createEffect(() => {
    const interval = setInterval(() => {
      setState((prev) => !prev);
    }, 5000);

    onCleanup(() => clearInterval(interval));
  });

  return (
    <Suspense>
      <Show when={data()?.CurrentViewers && data()!.CurrentViewers > 1}>
        <div
          class="text-sm flex items-center gap-1 overflow-hidden text-roma-medium-grey"
          classList={{ [`${props.class}`]: !!props.class }}
        >
          <p>{data()!.CurrentViewers} people viewing this product</p>
          <Show when={!!state()}>
            <Motion.div
              initial={{ y: "-100%", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "-100%", opacity: 0 }}
            >
              <Icon path={theEnrapturedMasses} class="w-5 h-5" />
            </Motion.div>
          </Show>
          <Show when={!state()}>
            <Motion.div
              initial={{ y: "100%", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "100%", opacity: 0 }}
            >
              <Icon
                path={
                  data()!.CurrentViewers > THIS_ITEM_IS_HOT
                    ? letItConsumeYou
                    : theAllSeeingEye
                }
                class={`w-5 h-5 ${
                  data()!.CurrentViewers > THIS_ITEM_IS_HOT
                    ? "animate-pulse"
                    : ""
                }`}
              />
            </Motion.div>
          </Show>
        </div>
      </Show>
    </Suspense>
  );
};
